<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import FormStepDefinition from '@/components/FormSteps/FormStepDefinition.vue';
import FormStepMatrixDefinition from '@/components/FormSteps/FormStepMatrixDefinition.vue';
import FormStepMapDefinition from '@/components/FormSteps/FormStepMapDefinition.vue';
import FormStepDotVotingChoice from '@/components/FormSteps/FormStepDotVotingChoice.vue';

import type { DotVotingStepDto, FormDto, Locales } from '@/services/types/api.types';
import { Constants } from '@/constants';

// PROPS
const props = defineProps<{
  form: FormDto;
  languageEnabled: Locales[];
}>();

// CONST
const { t } = useI18n();
</script>
<template>
  <div class="form-step-configuration">
    <div v-if="props.form.type === Constants.Form.Type.Proposal">
      {{ t('form.type.choicesLabel.proposal') }}
    </div>
    <div v-else-if="props.form.type === Constants.Form.Type.Question">
      <div v-for="(step, index) in props.form.answers.steps" :key="`${props.form.id}-${step.id}`">
        <form-step-definition
          :form-id="props.form.id"
          :step="step"
          :step-index="index"
          :permissions="{ canChoicesBeDeleted: props.form.canChoicesBeDeleted }"
          :languageEnabled="languageEnabled"
        />
      </div>
    </div>
    <div v-else-if="props.form.type === Constants.Form.Type.OpenQuestion">
      {{ t('form.type.choicesLabel.openQuestion') }}
    </div>
    <div v-else-if="props.form.type === Constants.Form.Type.Matrix">
      <div v-for="(step, index) in props.form.answers.steps" :key="`${props.form.id}-${step.id}`">
        <form-step-matrix-definition
          :form-id="props.form.id"
          :step="step"
          :step-index="index"
          :permissions="{ canChoicesBeDeleted: props.form.canChoicesBeDeleted }"
          :languageEnabled="languageEnabled"
        />
      </div>
    </div>
    <div v-else-if="props.form.type === Constants.Form.Type.Map">
      <div v-for="(step, index) in props.form.answers.steps" :key="`${props.form.id}-${step.id}`">
        <form-step-map-definition
          :form-id="props.form.id"
          :step="step"
          :step-index="index"
          :languageEnabled="languageEnabled"
        />
      </div>
    </div>
    <div v-else-if="props.form.type === Constants.Form.Type.DotVoting">
      <div v-for="step in props.form.answers.steps" :key="`${props.form.id}-${step.id}`">
        <form-step-dot-voting-choice
          :form-id="props.form.id"
          :step="step as DotVotingStepDto"
          :permissions="{ canChoicesBeDeleted: props.form.canChoicesBeDeleted }"
          :languageEnabled="languageEnabled"
        />
      </div>
    </div>
  </div>
</template>
